import { SwiperOptions } from "swiper/types";

export const imageSwiperOptions: SwiperOptions = {
  spaceBetween: 30,
  centeredSlides: true,
  navigation: true,
  pagination: {
    clickable: true,
  },
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  injectStyles: [
    `
.swiper, .image-swiper {
    overflow: visible;     

    .swiper-pagination {
        position: relative;
        margin-top: 2rem;

        .swiper-pagination-bullet {
            width: 0.75rem;
            height: 0.75rem;

            &.swiper-pagination-bullet-active {
                background: $primary;
            }
        }
    }  

    .swiper-button-next,
      .swiper-button-prev {
        color: white;
      }

      .swiper-button-prev {
        left: $spacer;
      }

      .swiper-button-next {
        right: $spacer;
      }

    @include media-breakpoint-up(lg) {

    .swiper-button-prev {
        left: 16%;
    }

    .swiper-button-next {
        right: 16%;
    }

    .swiper-slide {
        transition: opacity 0.4s;

        &.swiper-slide-next,
        &.swiper-slide-prev {
          opacity: 0.1;
        }
    }

      }

   }
    `,
  ],
  breakpoints: {
    992: {
      slidesPerView: 1.3,
    },
  },
};
